export default "__VITE_ASSET__BHKrXIuj__"